import {
  Box,
  styled,
  TableRow,
  TableCell,
  Button,
  Grid,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import { Link } from 'react-router-dom';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';

const tableHead = ['role id', 'role name', 'role description', 'จำนวน ผู้ใช้', 'เพิ่มเติม'];
interface UserRoleDashboard {
  id: number;
  role_name: string;
  role_description: string;
  is_super_role?: boolean;
  user_count: number;
}
const UserRoleManagement: React.FC = () => {
  const [data, setData] = useState<TableResponse<UserRoleDashboard> | null>(null);

  const [filterName, setFilterName] = useState<string>('');
  const [filterRoleID, setFilterRoleID] = useState<string>('');
  const [filterDescription, setFilterDescription] = useState<string>('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (filterName == '' && filterRoleID == '' && filterDescription == '') {
      const searchParams = new URLSearchParams();
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      searchParams.set('is_sync', `${true}`);
      api
        .get<TableResponse<UserRoleDashboard>>(`/user_role/table`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setData(data);
        });
      return;
    }
    const timeOut = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterRoleID) {
        searchParams.set('id', `${filterRoleID}`);
      }
      if (filterDescription) {
        searchParams.set('description', `${filterDescription}`);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api
        .get<TableResponse<UserRoleDashboard>>(`/user_role/table`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setData(data);
        });
    }, 500);
    return () => clearTimeout(timeOut);
  }, [filterName, filterRoleID, filterDescription, page, rowsPerPage]);
  return (
    <Container>
      <PageHeader text="User Role" />
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหา Role ID"
            variant="outlined"
            placeholder="ค้นหา Role ID"
            value={filterRoleID}
            onChange={(event) => setFilterRoleID(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหาชื่อ Role"
            variant="outlined"
            placeholder="ค้นหาชื่อ Role"
            value={filterName}
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหา Role Description"
            variant="outlined"
            placeholder="ค้นหา Role Description"
            value={filterDescription}
            onChange={(event) => setFilterDescription(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md sx={{ display: 'flex', justifyContent: 'end', height: '50px' }}>
          <Button component={Link} to={`/user-role/create`} variant="contained" color="primary">
            เพิ่มข้อมูล
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={tableHead}
          count={data?.total ? data.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              <TableCell align="center">{data.id}</TableCell>
              <TableCell align="center">{data.role_name}</TableCell>
              <TableCell align="center">{data.role_description}</TableCell>
              <TableCell align="center">{data.user_count}</TableCell>

              <TableCell align="center">
                <Grid container spacing={2} rowSpacing={2} justifyContent="center">
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/user-role/${data.id}/edit`}
                      variant="contained"
                      color="warning"
                    >
                      แก้ไข
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default UserRoleManagement;

const Container = styled('div')`
  padding: 24px;
`;
